import { uuid } from '@utils/common';

export const skipEmptyFieldsOptions = [
	{
		value: true,
		label: 'Yes',
		id: uuid(),
	},
	{
		value: false,
		label: 'No',
		id: uuid(),
	},
];
